import {
  LayoutDashboard,
  Link,
  UsersRound,
  UserRoundPen,
  UserRoundCheck,
  Shield,
  UserPlus,
  ContactRound,
  UserRound,
  UserRoundCog,
  HandCoins,
  ChartCandlestick,
  FileUser,
  Gift,
  UserX,
  SendToBack,
  History,
  Bot,
  Newspaper,
} from "lucide-react";

export type Route = {
  link: string;
  label: string;
  icon: JSX.Element;
};

const homeRoutes: Route[] = [
  {
    label: "Главная",
    link: "/",
    icon: <LayoutDashboard className="stroke-textColor" size={20} />,
  },
];

const botRoutes: Route[] = [
  {
    label: "Мои Боты",
    link: "/bots",
    icon: <Bot className="stroke-textColor" size={20} />,
  },
];

const headNavRoutes: Route[] = [
  {
    label: "Все лиды",
    link: "/head/all-leads",
    icon: <FileUser className="stroke-textColor" size={20} />,
  },
  {
    label: "Профиты",
    link: "/head/profits",
    icon: <ChartCandlestick className="stroke-textColor" size={20} />,
  },
  {
    label: "Доступы",
    link: "/head/access",
    icon: <Shield className="stroke-textColor" size={20} />,
  },
  {
    label: "Мои ссылки",
    link: "/worker/links",
    icon: <UserRound className="stroke-textColor" size={20} />,
  },
  {
    label: "Мои лиды",
    link: "/worker/leads",
    icon: <UserRoundCheck className="stroke-textColor" size={20} />,
  },
  {
    label: "Воркеры",
    link: "/head/workers",
    icon: <UsersRound className="stroke-textColor" size={20} />,
  },
  {
    label: "Менеджеры",
    link: "/teamlead/managers",
    icon: <UserRoundPen className="stroke-textColor" size={20} />,
  },
  {
    label: "Наставники",
    link: "/mentors",
    icon: <UsersRound className="stroke-textColor" size={20} />,
  },
  {
    label: "Выплаты",
    link: "/head/payouts",
    icon: <HandCoins className="stroke-textColor" size={20} />,
  },
  {
    label: "Модераторы",
    link: "/head/moderators",
    icon: <UserRoundCog className="stroke-textColor" size={20} />,
  },
  {
    label: "Розыгрыши",
    link: "/head/giveaways",
    icon: <Gift className="stroke-textColor" size={20} />,
  },
  {
    label: "Трафик менеджеры",
    link: "/traffic_managers/",
    icon: <UsersRound className="stroke-textColor" size={20} />,
  },
  {
    label: "Сделки",
    link: "/offers",
    icon: <SendToBack className="stroke-textColor" size={20} />,
  },
  {
    label: "Анкеты наставников",
    link: "/mentor-profiles",
    icon: <Newspaper className="stroke-textColor" size={20} />,
  },
];

const workerNavRoutes: Route[] = [
  {
    label: "Лиды",
    link: "/worker/leads",
    icon: <UsersRound className="stroke-textColor" size={20} />,
  },
  {
    label: "Список ссылок",
    link: "/worker/links",
    icon: <Link className="stroke-textColor" size={20} />,
  },
  {
    label: "Сделки",
    link: "/offers",
    icon: <SendToBack className="stroke-textColor" size={20} />,
  },
  {
    label: "История депозитов",
    link: "/deposits-history",
    icon: <History className="stroke-textColor" size={20} />,
  },
  {
    label: "Аналитика",
    link: "/analytics",
    icon: <ChartCandlestick className="stroke-textColor" size={20} />,
  },
];

export const mentorNavRoutes: Route[] = [
  {
    label: "Список учеников",
    link: "/mentor/students",
    icon: <ContactRound className="stroke-textColor" size={20} />,
  },
];

export const managerNavRoutes: Route[] = [
  {
    label: "Лиды",
    link: "/manager/leads",
    icon: <UserRoundPen className="stroke-textColor" size={20} />,
  },
];

export const teamleadNavRoutes: Route[] = [
  {
    label: "Лиды",
    link: "/teamlead/leads",
    icon: <UserRoundCheck className="stroke-textColor" size={20} />,
  },
  {
    label: "Менеджеры",
    link: "/teamlead/managers",
    icon: <UserRoundPen className="stroke-textColor" size={20} />,
  },
  {
    label: "Доступы",
    link: "/teamlead/access",
    icon: <Shield className="stroke-textColor" size={20} />,
  },
];

const moderatorNavRoutes: Route[] = [
  {
    label: "Заявки",
    link: "/moderator/requests/candidates",
    icon: <UserPlus className="stroke-textColor" size={20} />,
  },
  {
    label: "Неактивные воркеры",
    link: "/moderator/inactive-workers",
    icon: <UserX className="stroke-textColor" size={20} />,
  },
];

const mastersNavRoutes: Route[] = [
  {
    label: "Доступы",
    link: "/master/access",
    icon: <Shield className="stroke-textColor" size={20} />,
  },
];

const masterMentorNavRoutes: Route[] = [
  {
    label: "Наставники",
    link: "/mentors",
    icon: <UsersRound className="stroke-textColor" size={20} />,
  },
  {
    label: "Анкеты наставников",
    link: "/mentor-profiles",
    icon: <Newspaper className="stroke-textColor" size={20} />,
  },
];

const masterTrafficManagerRoutes: Route[] = [
  {
    label: "Байеры",
    link: "/mentor/students/",
    icon: <ContactRound className="stroke-textColor" size={20} />,
  },
  {
    label: "Трафик менеджеры",
    link: "/traffic_managers/",
    icon: <UsersRound className="stroke-textColor" size={20} />,
  },
];

export const getNavRoutes = (role: string) => {
  switch (role) {
    case "head":
      return [
        ...homeRoutes,
        ...headNavRoutes,
        ...moderatorNavRoutes,
        ...botRoutes,
      ];
    case "worker":
      return [...homeRoutes, ...workerNavRoutes, ...botRoutes];
    case "traffic_manager":
    case "mentor":
      return [...homeRoutes, ...mentorNavRoutes];
    case "manager":
      return [...homeRoutes, ...managerNavRoutes];
    case "teamlead":
      return [...homeRoutes, ...teamleadNavRoutes];
    case "master_teamlead":
      return [...homeRoutes, ...teamleadNavRoutes];
    case "master_mentor":
      return [
        ...homeRoutes,
        ...mentorNavRoutes,
        ...mastersNavRoutes,
        ...masterMentorNavRoutes,
      ];
    case "moderator":
      return [
        ...homeRoutes,
        ...moderatorNavRoutes,
        ...workerNavRoutes,
        ...botRoutes,
      ];
    case "master_moderator":
      return [
        ...homeRoutes,
        ...moderatorNavRoutes,
        ...workerNavRoutes,
        ...mastersNavRoutes,
        ...botRoutes,
      ];
    case "master_traffic_manager":
      return [
        ...homeRoutes,
        ...masterTrafficManagerRoutes,
        ...mastersNavRoutes,
      ];

    default:
      return [];
  }
};
